
export default {
    ObserveForLazyLoad() {


        // create config object: rootMargin and threshold
        // are two properties exposed by the interface
        const config = {
            rootMargin: '0px 0px 50px 0px',
            threshold: 0
        };

        // register the config object with an instance
        // of intersectionObserver
        let observer = new IntersectionObserver(function (entries, self) {
            // iterate over each entry
            entries.forEach(entry => {
                // process just the images that are intersecting.
                // isIntersecting is a property exposed by the interface
                if (entry.isIntersecting) {
                    // custom function that copies the path to the img
                    // from data-src to src
                    let src = entry.target.dataset.src;
                    $(entry.target).hide();
                    entry.target.style.backgroundImage = 'url("' + src + '")';
                    $(entry.target).fadeIn(1000);
                    // the image is now in place, stop watching
                    self.unobserve(entry.target);
                }
            });
        }, config);


        const imgs = document.querySelectorAll('.bglazyload');
        imgs.forEach(img => {

            // observer.observe(img);

            var lazy = $(img);
            var src = lazy.attr('data-src');
            lazy.css('background-image', 'url("' + src + '")');

        });
    }




}
